import { APIKeyInterceptor } from "./api-key.interceptor";
import { HTTP_INTERCEPTORS } from "@angular/common/http";

export const API_KEY_INTERCEPTOR_INITIALIZER_PROVIDER = [
    {
        provide: HTTP_INTERCEPTORS, useClass: APIKeyInterceptor, multi: true
    }
];
